import { LANGUAGES_DICTIONARY } from '@usercentrics/template-app-translations';

export default (language: string, ISO: string) =>
  `${LANGUAGES_DICTIONARY[language as keyof typeof LANGUAGES_DICTIONARY]} (${ISO?.toUpperCase()})`;
